import * as React from 'react'

import IQuestion from '../../../data/questionnaires/IQuestion'

import { Typography } from '@material-ui/core'

import './style.scss'

interface IProps {
  question: IQuestion
}
interface IState {}

class Question extends React.Component<IProps, IState> {
  render() {
    const {
      question: { question, assetsSrc }
    } = this.props

    const isOdd = num => num % 2

    let title = question.split('###').map((p, i) => (
      <React.Fragment key={i}>
        {p}
        {assetsSrc && assetsSrc[i] && (
          <img className="question-title-image" src={assetsSrc[i]} />
        )}
      </React.Fragment>
    ))
    if (!assetsSrc) {
      title = question.split('@@@').map((p, i) => (
        <span key={i}>
          <span className={isOdd(i) ? 'italic' : ''}>{p}</span>
        </span>
      ))
    }
    return (
      <div className="question">
        <Typography className="question-title">{title}</Typography>
      </div>
    )
  }
}

export default Question



// WEBPACK FOOTER //
// ./src/pages/Questionnaires/Question/index.tsx